export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11263.d5185451.jpg";